import Offcanvas from 'bootstrap/js/src/offcanvas';

window.bootstrap = window.bootstrap || {};
window.bootstrap.Offcanvas = Offcanvas;
